export { namespace } from './actions';
import { loadingStatus } from '../../../../helpers/constant';
import { ACTION_TYPES, COMPONENTS } from './actions';

const initialState = {
  scheduleReports: [],
  loadingState: {
    [COMPONENTS.LIST]: {
      loaded: true,
      loading: false
    },
    [COMPONENTS.SCHEDULE_REPORT_FORM]: {
      loaded: true,
      loading: false
    },
    [COMPONENTS.DELETE_REPORT]: {},
    [COMPONENTS.REPORT]: {
      status: loadingStatus.idle ,
    }
  }
};

export default function scheduleReport(state = initialState, action) {
  switch (action.type) {
    case ACTION_TYPES.SET_SCHEDULE_REPORTS: {
      const { data } = action.payload;
      return {
        ...state,
        scheduleReports: data
      };
    }

    case ACTION_TYPES.ADD_SCHEDULE_REPORT: {
      const { scheduleReport } = action.payload;
      return {
        ...state,
        scheduleReports: [scheduleReport, ...state.scheduleReports]
      };
    }

    case ACTION_TYPES.MODIFY_REPORT: {
      const {
        report: newReport,
        reportId
      } = action.payload;
      const updatedReportIndex = state.scheduleReports.findIndex(
        scheduleReport => scheduleReport.reportId === reportId
      );
      let newScheduleReportState = [];
      // update existed report
      if (updatedReportIndex !== -1) {
        newScheduleReportState = state.scheduleReports.map(report =>
          report.reportId === reportId
            ? { ...report, ...newReport }
            : report
        );
      } else {
        // set new report for the campaign
        newScheduleReportState = [newReport, ...state.scheduleReports]
      }

      return {
        ...state,
        scheduleReports: newScheduleReportState
      };
    }

    case ACTION_TYPES.REMOVE_REPORT: {
      const { reportId } = action.payload;
      const newScheduleReportState = state.scheduleReports.filter(
        scheduleReport => scheduleReport.reportId !== reportId
      );

      return {
        ...state,
        scheduleReports: newScheduleReportState
      };
    }

    case ACTION_TYPES.LOAD_REPORT: {
      const { component, loading, loaded, reportId, hasError } = action.payload;
      const newLoadingState = {...state.loadingState};
      if (reportId) {
        newLoadingState[component][reportId] = {
          loaded,
          loading,
          hasError,
        }
      } else {
        newLoadingState[component] = {
          loaded, 
          loading,
          hasError,
        }
      }

      return {
        ...state,
        loadingState: newLoadingState,
      };
    }

    case ACTION_TYPES.UPDATE_LOADING_STATUS: {
      const {
        component,
        loadingStatus,
      } = action.payload;
      return {
        ...state,
        loadingState: {
          ...state.loadingState,
          [component]: loadingStatus,
        }
      }
    }

    default:
      return state;
  }
}
